import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import SubNavbar from '../components/SubNavbar';
import ActionButton from '../../ActionButton';
import { lookbookManageFlowShowPreview } from '../../../sagas/lookbooks/manageFlow/actions';
import { getRouteName } from '../../../utils/routesNames';

import './_lookbookNav.scss';

const LookbookNav = ({ isPreview }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = useLocation();
  const { showPreview } = useSelector(s => s.lookbookManageFlow);

  return (
    <div className="lookbookNav">
      {/*<SubNavbar route={`${getRouteName(pathname)} ${!isEmpty(dataTable) ? '(' + dataTable.length + ')' : ''}`}>*/}
      <SubNavbar route={getRouteName(pathname)}>
        <ActionButton
          variant="secondary"
          title={showPreview ? (isPreview ? 'Back' : 'Back to form') : 'Show preview'}
          onClick={() => isPreview ? history.goBack() : dispatch(lookbookManageFlowShowPreview(!showPreview))}
        />
      </SubNavbar>
    </div>
  );
};

LookbookNav.propTypes = {
  isPreview: PropTypes.bool
};

export default LookbookNav;